/**
 * `31.1` (`РГ-07`, `РГ-11`): отказ по колонке «Место установки» — у самой ячейки.
 *
 * Ввод в колонке заводит машиноместо и связь станции с ним, поэтому отказ приходит
 * от сервера: «место 17 уже у станции 1» (`409`) или «нужен объект машиноместа»
 * (`400`). Показывать его общим тостом нельзя: человек правит **строку таблицы**, и
 * причина должна стоять там, где он ошибся, — иначе непонятно, к какой из станций
 * относится отказ.
 *
 * Правило простое: сервер назвал причину — показываем её; не назвал — общая фраза,
 * но всё равно у ячейки.
 */
export const PLACE_CELL_FALLBACK =
  "изменение места не принято — причина не названа сервером";

interface PlaceCellErrorSource {
  response?: {
    status?: number;
    data?: {
      error?: string;
      message?: string;
      errors?: Array<{ field?: string; message?: string }>;
    };
  };
  message?: string;
}

/** Причина отказа по месту из ответа сервера. `null` — отказа не было. */
export function placeCellError(error: any): string | null {
  if (!error) return null;

  const source = error as PlaceCellErrorSource;
  const data = source.response?.data;
  const status = source.response?.status;

  // Полевые отказы проверки ввода: берём причину именно по месту.
  const fieldError = Array.isArray(data?.errors)
    ? data.errors.find((item) => item?.field === "place")
    : undefined;

  if (fieldError?.message) return fieldError.message;

  if (data?.error) return data.error;
  if (data?.message) return data.message;

  // Отклика нет вовсе (сеть): своя фраза, и всё равно у ячейки.
  if (!status && source.message) return `изменение места не принято: ${source.message}`;

  return PLACE_CELL_FALLBACK;
}
